import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-253">
      <button className="w-full py-5 flex items-center justify-between text-left focus:outline-none group" onClick={onClick} data-id="element-254">
        <span className="font-semibold text-brand-navy group-hover:text-brand-orange transition-colors pr-4 text-lg" data-id="element-255">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0 text-brand-orange" data-id="element-256">
          <ChevronDown size={24} data-id="element-257" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-258">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-259">
            <div className="pb-5 text-gray-600 leading-relaxed" data-id="element-260">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
const faqs = [{
  q: '¿Cómo recibo el pack después de comprar?',
  a: 'Recibís acceso inmediato al descargarlo apenas completes el pago.'
}, {
  q: '¿Necesito alguna app especial para usarlo?',
  a: 'No. Solo necesitás abrir el PDF desde cualquier dispositivo.'
}, {
  q: '¿Sirve para imprimir en casa?',
  a: 'Sí. Está preparado para impresión doméstica.'
}, {
  q: '¿Qué edades incluye?',
  a: 'Ideal para niños de 4 a 8 años.'
}, {
  q: '¿Puedo usarlo en clase o con varios niños?',
  a: 'Sí. Es perfecto para familias, profesores, niñeras y actividades grupales.'
}, {
  q: '¿Las actividades vienen organizadas?',
  a: 'Sí. Todo está separado por categorías y temáticas para encontrar actividades rápido.'
}, {
  q: '¿Los bonus están incluidos?',
  a: 'Sí. Todos los bonus vienen incluidos sin costo extra.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. Tenés 7 días de garantía total.'
}];
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="bg-white rounded-2xl shadow-card p-6 md:p-8" data-id="element-261">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-262" />)}
    </div>;
}